export const SaveSupplierCategoryListDetails = async (suplierCategoryArray) => {

    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(suplierCategoryArray)
        };

        const response = await fetch(`${ApiURL}SupplierCategory/listupload`, requestOptions);

        const result = await response.json();
        if (!result.success) {
            return { success: false, data: result.data, message: result.message };
        }

        return { success: true, data: result.data, message: result.message };
    } catch (error) {
        console.error("SaveSupplierCategory error:", error)
        //throw error; // Rethrow the error to be handled by the caller
    }
};

// ********Save/Update button function API */
export const SaveSupplierCategory = async (SuplierCategoty) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(SuplierCategoty)
        };

        const response = await fetch(`${ApiURL}SupplierCategory`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.data == "Record Already Exsist!") {
                return { success: false, data: responseData.data };
            } else if (responseData.data == "Code Already Exsist!") {
                return { success: false, data: responseData.data };
            } else {
                return { success: true, data: responseData.data };
            }
        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("SaveSupplierCategory error:", error);
        return { success: false, data: "An error occurred." };
    }
};
// ********End of Save/Update button function API */


// ********Delete button function API */

export const DeleteSupplierCategory = async (rowDelete) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(rowDelete)
        }

        const response = await fetch(`${ApiURL}Common/Delete`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {

            if (responseData.data == "Cannot Delete, Record Already Used!") {
                return { success: false, data: responseData.data };

            } else {
                return { success: true, data: responseData.data };
            }

        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("DeleteSupplierCategory error:", error);
    }
};

// ********End of Delete button function API */


//*** Get and Set values when user search code function API*/
export const SupplierCategorysetCodeFind = async (CodeFind) => {
    try {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },

        };

        const response = await fetch(`${ApiURL}SupplierCategory/search/${CodeFind}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success && responseData.data.length > 0) {
                return { success: true, data: responseData.data[0] };
            }
        } else {
            return { success: false, data: {} };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}

// *** End of Get and Set values when user search code function API*/

